module.exports = __webpack_public_path__ + "static/img/B (11).3282d542.png";